import type { PageExperience } from '@/features/experiences/types';
import type { BlockLayouts } from '@/types/gql.generated';
import { Flex, Icon } from '@/ui';
import {
  SidebarCard,
  SidebarIconChip,
  SidebarRow,
  SidebarRowLabel,
  SidebarSection,
} from '../SidebarKit';
import { DayColumnsBySelect } from './DayColumnsBySelect';

type Props = {
  experience: PageExperience;
  onSetBlockLayout: (blockId: string, layout: BlockLayouts) => void;
};

export const DayColumnsSection = ({ experience, onSetBlockLayout }: Props) => (
  <SidebarSection label="Columns">
    <SidebarCard overflow="visible">
      <SidebarRow>
        <Flex align="center" flexShrink={0} gap={2.5}>
          <SidebarIconChip size="26px">
            <Icon color="ink.soft" icon="Layout" size={3.5} />
          </SidebarIconChip>
          <SidebarRowLabel label="Columns by" />
        </Flex>
        <DayColumnsBySelect
          experience={experience}
          onSetBlockLayout={onSetBlockLayout}
        />
      </SidebarRow>
    </SidebarCard>
  </SidebarSection>
);
